import type React from 'react';

import { useGetResources } from '@hooks/useGetResources';
import { FagomradeType } from '@src/types/minhelseentities';

import TagComponent from './tag-component';

interface Props {
  fagomrade: FagomradeType;
}

const FagomradeTag = ({ fagomrade }: Props): React.JSX.Element | null => {
  const resources = useGetResources();

  switch (fagomrade) {
    case FagomradeType.PSYKISK_HELSE:
      return <TagComponent tagValue={resources?.fagomrade_psykiskHelse} />;
    case FagomradeType.SYKDOM_OG_SKADER:
      return <TagComponent tagValue={resources?.fagomrade_sykdomOgSkader} />;
    case FagomradeType.LIVSSTIL_OG_TRENING:
      return <TagComponent tagValue={resources?.fagomrade_livsstilOgTrening} />;
    case FagomradeType.TANKER_OG_FOLELSER:
      return <TagComponent tagValue={resources?.fagomrade_tankerOgFolelser} />;
    case FagomradeType.GRAVIDITET_OG_FODSEL:
      return <TagComponent tagValue={resources?.fagomrade_graviditetOgFodsel} />;
    case FagomradeType.RAAD_OG_TIPS_I_HVERDAGEN:
      return <TagComponent tagValue={resources?.fagomrade_raadOgTipsIHverdagen} />;
    default:
      return null;
  }
};

export default FagomradeTag;
